import React from 'react'
import styles from './Style.module.css'

const SwitchSlider = ({ labelText, checked, onChange, customClassLabel, customClassLabelText, customClassSwitch, customClassSlider }) => {
  return (
    <label className={`${styles.toggleLabel} ${customClassLabel}`}>
        <span className={`${styles.labelText} ${customClassLabelText}`}>{labelText}</span>
        <label className={`${styles.switch} ${customClassSwitch}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => {
                    const isChecked = e.target.checked;
                    onChange(isChecked);
                }}
            />
            <span className={`${styles.slider} ${customClassSlider}`}></span>
        </label>
    </label>
  )
}

export default SwitchSlider